const objectArray = (value) => {
    if (!Array.isArray(value)) return [];
    return value.filter(
        (item) => item !== null && typeof item === "object" && !Array.isArray(item)
    );
};

export function normalizeHomePageData(payloads = {}) {
    const fields = {
        categories: payloads.categories?.categories,
        featured: payloads.featured?.items,
        newest: payloads.newest?.items,
        urgentRequests: payloads.urgentRequests?.items,
        topProducers: payloads.topProducers?.items,
        marketProducts: (
            payloads.marketProducts?.items
            ?? payloads.marketProducts?.products
        ),
    };

    return {
        categories: objectArray(fields.categories),
        featured: objectArray(fields.featured),
        newest: objectArray(fields.newest),
        urgentRequests: objectArray(fields.urgentRequests),
        topProducers: objectArray(fields.topProducers),
        marketProducts: objectArray(fields.marketProducts),
        available: Object.fromEntries(
            Object.entries(fields).map(([key, value]) => [key, Array.isArray(value)])
        ),
    };
}

const PRICE_CATEGORY_ORDER = ["frutas", "hortalizas", "granos", "pecuarios"];

export function selectHomePricePreview(products, limit = 4) {
    const eligible = objectArray(products).filter(
        (product) => product.slug && product.latest && [
            "current_official",
            "latest_official_available",
        ].includes(product.public_status)
    );
    const selected = [];
    const selectedSlugs = new Set();

    for (const category of PRICE_CATEGORY_ORDER) {
        const product = eligible.find((candidate) => (
            candidate.category === category && !selectedSlugs.has(candidate.slug)
        ));
        if (product) {
            selected.push(product);
            selectedSlugs.add(product.slug);
        }
    }
    for (const product of eligible) {
        if (selected.length >= limit) break;
        if (!selectedSlugs.has(product.slug)) {
            selected.push(product);
            selectedSlugs.add(product.slug);
        }
    }
    return selected.slice(0, limit);
}
